import { render } from "./UserList2.vue?vue&type=template&id=7a6dfb96&scoped=true"
import script from "./UserList2.vue?vue&type=script&lang=ts"
export * from "./UserList2.vue?vue&type=script&lang=ts"

import "./UserList2.vue?vue&type=style&index=0&id=7a6dfb96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a6dfb96"

export default script